import React from 'react';
import { Calendar } from 'lucide-react';

interface DatePickerProps {
  value: Date | null;
  onChange: (date: Date | null) => void;
  label?: string;
  placeholder?: string;
  className?: string;
  min?: Date;
  max?: Date;
}

export const DatePicker: React.FC<DatePickerProps> = ({
  value,
  onChange,
  label,
  placeholder = 'Select date...',
  className = '',
  min,
  max,
}) => {
  return (
    <div className={`space-y-2 ${className}`}>
      {label && (
        <label 
          className="block text-sm font-medium"
          style={{ color: 'var(--color-text)', opacity: 0.8 }}
        >
          {label}
        </label>
      )}
      <div className="relative">
        <input
          type="datetime-local"
          value={value ? value.toISOString().slice(0, 16) : ''}
          onChange={(e) => {
            const date = e.target.value ? new Date(e.target.value) : null;
            onChange(date);
          }}
          min={min?.toISOString().slice(0, 16)}
          max={max?.toISOString().slice(0, 16)}
          className="w-full pl-10 pr-4 py-2 rounded-lg focus:ring-2 focus:border-transparent"
          style={{
            backgroundColor: 'var(--color-card-bg)',
            borderColor: 'var(--color-border)',
            borderWidth: '1px',
            color: 'var(--color-text)'
          }}
          placeholder={placeholder}
        />
        <Calendar 
          className="absolute left-3 top-1/2 transform -translate-y-1/2" 
          size={16}
          style={{ color: 'var(--color-text)', opacity: 0.6 }}
        />
      </div>
    </div>
  );
};
